import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import git from '../../../assets/icons/github.png'
import '../../../Styles/project.css'

const Project = ({ service }) => {
    const { name, des, img, technology, github, site } = service

    return (
        <div data-aos="zoom-in" data-aos-duration="2000" class="text-dark mb-5">
            <h3 class="text-center text-color mb-3">{name}</h3>
            <div class="project-card rounded-lg shadow-lg">
                <img src={img} alt={name} />
                <div class="project-container">
                    <h5 class="text-center">{name}</h5>
                    <p>{des}</p>
                    <strong>Technology : {technology}</strong>
                    <div class="flex items-center gap-3 mt-2">
                        <a href={site} target="_blank" rel="noreferrer">
                            <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="text-blue-600 w-6 h-6 mt-1" />
                        </a>
                        <a href={github} target="_blank" rel="noreferrer">
                            <img style={{ height: '30px' }} src={git} alt="" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Project
